import { useEffect, useState } from "react";
import CustomPagination from "../../table/CustomPagination";
import Loader from "../../loading/Loader";
import { useUsageAnalytics } from "../../../contexts/UsageAnalyticsContext";
import UsageAnalyticsTable from "./UsageAnalytics/UsageAnalyticsTable";

const UsageAnalytics: React.FC = () => {
  const { usageData, totalPages, currentPage, hasPreviousPage, hasNextPage, loading, fetchUsageData } = useUsageAnalytics();

  useEffect(() => {
    fetchUsageData(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage: number) => {
    fetchUsageData(newPage);
  };

  return (
    <div className="flex flex-col w-full overflow-hidden border divide-y divide-gorgonzola-blue-50 rounded-xl border-gorgonzola-blue-50">
      <div className="flex flex-col justify-between w-full gap-2.5 p-4 md:py-6 md:items-center md:flex-row md:gap-0">
        <h2 className="font-bold text-closed-shutter-300">All Usage</h2>
      </div>

      <div className="w-full p-4 md:p-6">
        <div className="flex flex-col w-full border divide-y rounded-md divide-gorgonzola-blue-50 border-gorgonzola-blue-50">
          <div className="flex flex-col justify-between w-full gap-2.5 p-4 md:py-6 md:items-center md:flex-row md:gap-0">
            <h2 className="font-bold text-closed-shutter-300">Requests Table</h2>
          </div>

          {loading ? (
            <div className="flex justify-center w-full p-4 md:p-6">
              <Loader />
            </div>
          ) : usageData.length > 0 ? (
            <>
              <UsageAnalyticsTable usageData={usageData} />

              <CustomPagination currentPage={currentPage} totalPages={totalPages} hasPreviousPage={hasPreviousPage} hasNextPage={hasNextPage} onPageChange={handlePageChange} />
            </>
          ) : (
            <div className="p-6 text-center">
              <p className="text-closed-shutter-300">No usage data found</p>
              <p className="mt-2 text-xs text-closed-shutter-200">There are no usage data matching your filters.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UsageAnalytics;
